<template>
  <scout-form
    :is-modified="!!value || value === 0"
    label="転職回数"
    half
  >
    <select
      :value="value"
      class="boss-input-select"
      data-test="select-changed-jobs"
      @change="$emit('input', $event.target.value ? Number($event.target.value) : null)"
    >
      <option value="">
        指定なし
      </option>
      <option
        v-for="(option, i) in options"
        :key="i"
        :value="option.id"
      >
        {{ option.name }}
      </option>
    </select>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  data () {
    return {
      options: definition.changeOverJobsCount
    }
  }
}
</script>
